import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import Newsletter from "../components/Newsletter";
import ServiceView from "../components/ServiceView";
import AppointmentTwo from "../components/AppointmentTwo";
import HeaderTwo from "../components/HeaderTwo";
import FooterThree from "../components/FooterThree";
import PortfolioThree from "../components/PortfolioThree";
import AboutThree from "../components/AboutThree";

const Service = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {/* Preloader */}
      {active === true && <Preloader />}

      {/* Helmet */}
      <HelmetReact title={"Service"} />

      {/* HeaderFive */}
      <HeaderTwo />

      {/* Breadcrumb */}
      <Breadcrumb title="Service" bg={"/assets/img/bg/servicesbanner.png"}/>

      <AboutThree />  
  
      {/* Newsletter */}
      <Newsletter />

      {/* FooterOne */}
      <FooterThree />

    </>
  );
};

export default Service;
